module.exports = __webpack_public_path__ + "img/JSB_WALLET2.5e6ab15c.png";